import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import id from 'date-fns/locale/id/index';

export const FETCH_COUPON_CONSUMER_REQUEST = 'FETCH_COUPON_CONSUMER_REQUEST';
export const FETCH_COUPON_CONSUMER_SUCCESS = 'FETCH_COUPON_CONSUMER_SUCCESS';
export const FETCH_COUPON_CONSUMER_ERROR = 'FETCH_COUPON_CONSUMER_ERROR';

export const FETCH_COUPON_CONSUMER_DETAIL_REQUEST = 'FETCH_COUPON_CONSUMER_DETAIL_REQUEST';
export const FETCH_COUPON_CONSUMER_DETAIL_SUCCESS = 'FETCH_COUPON_CONSUMER_DETAIL_SUCCESS';
export const FETCH_COUPON_CONSUMER_DETAIL_ERROR = 'FETCH_COUPON_CONSUMER_DETAIL_ERROR';

export const GET_COUPON_CONSUMER_DETAIL_REQUEST = 'GET_COUPON_CONSUMER_DETAIL_REQUEST';
export const GET_COUPON_CONSUMER_DETAIL_SUCCESS = 'GET_COUPON_CONSUMER_DETAIL_SUCCESS';
export const GET_COUPON_CONSUMER_DETAIL_ERROR = 'GET_COUPON_CONSUMER_DETAIL_ERROR';

export const CREATE_COUPON_CONSUMER_REQUEST = 'CREATE_COUPON_CONSUMER_REQUEST';
export const CREATE_COUPON_CONSUMER_SUCCESS = 'CREATE_COUPON_CONSUMER_SUCCESS';
export const CREATE_COUPON_CONSUMER_ERROR = 'CREATE_COUPON_CONSUMER_ERROR';

export const UPDATE_COUPON_CONSUMER_REQUEST = 'UPDATE_COUPON_CONSUMER_REQUEST';
export const UPDATE_COUPON_CONSUMER_SUCCESS = 'UPDATE_COUPON_CONSUMER_SUCCESS';
export const UPDATE_COUPON_CONSUMER_ERROR = 'UPDATE_COUPON_CONSUMER_ERROR';

export const DELETE_COUPON_CONSUMER_REQUEST = 'DELETE_COUPON_CONSUMER_REQUEST';
export const DELETE_COUPON_CONSUMER_SUCCESS = 'DELETE_COUPON_CONSUMER_SUCCESS';
export const DELETE_COUPON_CONSUMER_ERROR = 'DELETE_COUPON_CONSUMER_ERROR';

export const FETCH_COUPON_OPTIONS_REQUEST =
    'FETCH_COUPON_OPTIONS_REQUEST';
export const FETCH_COUPON_OPTIONS_SUCCESS =
    'FETCH_COUPON_OPTIONS_SUCCESS';
export const FETCH_COUPON_OPTIONS_ERROR =
    'FETCH_COUPON_OPTIONS_ERROR';

export const fetchCouponConsumer = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_COUPON_CONSUMER_REQUEST, FETCH_COUPON_CONSUMER_SUCCESS, FETCH_COUPON_CONSUMER_ERROR],
            callAPI: () => ApiClient.post('payment/CouponConsumer/Search', data),
            payload: { data },
        }),
    );
};

export const createCouponConsumer = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [CREATE_COUPON_CONSUMER_REQUEST, CREATE_COUPON_CONSUMER_SUCCESS, CREATE_COUPON_CONSUMER_ERROR],
            callAPI: () => ApiClient.post('payment/CouponConsumer/Create', data),
            payload: { data, formId },
        }),
    );
};

export const updateCouponConsumer = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_COUPON_CONSUMER_REQUEST, UPDATE_COUPON_CONSUMER_SUCCESS, UPDATE_COUPON_CONSUMER_ERROR],
            callAPI: () => ApiClient.put(`payment/CouponConsumer/${id}`, data),
            payload: { data: { ...data, id }, formId },
        }),
    );
};

export const getCouponConsumerDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [GET_COUPON_CONSUMER_DETAIL_REQUEST, GET_COUPON_CONSUMER_DETAIL_SUCCESS, GET_COUPON_CONSUMER_DETAIL_ERROR],
            callAPI: () => ApiClient.get(`payment/CouponConsumer/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const fetchCouponConsumerOptions = () => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_COUPON_OPTIONS_REQUEST,
                FETCH_COUPON_OPTIONS_SUCCESS,
                FETCH_COUPON_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get('payment/CouponConsumer/GetSelectList'),
            payload: {},
        }),
    );
};

export const deleteCouponConsumer = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [DELETE_COUPON_CONSUMER_REQUEST, DELETE_COUPON_CONSUMER_SUCCESS, DELETE_COUPON_CONSUMER_ERROR],
            callAPI: () => ApiClient.delete(`payment/CouponConsumer/${id}`),
            payload: { data: { id } },
        }),
    );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
        case FETCH_COUPON_CONSUMER_REQUEST:
        case FETCH_COUPON_OPTIONS_REQUEST:
            return {
                ...state,
                payload,
                response: {},
                error: {},
                successMessage: '',
                errorMessage: '',
            };


        case FETCH_COUPON_CONSUMER_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case FETCH_COUPON_OPTIONS_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    options: response.data.data,
                },
                response,
                successMessage,
            };

        case GET_COUPON_CONSUMER_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };

        case CREATE_COUPON_CONSUMER_SUCCESS:
        case UPDATE_COUPON_CONSUMER_SUCCESS:
        case DELETE_COUPON_CONSUMER_SUCCESS:
            return {
                ...state,
                response,
                successMessage,
            };

        case FETCH_COUPON_CONSUMER_ERROR:
        case CREATE_COUPON_CONSUMER_ERROR:
        case UPDATE_COUPON_CONSUMER_ERROR:
        case FETCH_COUPON_OPTIONS_ERROR:
        case DELETE_COUPON_CONSUMER_ERROR:
            return {
                ...state,
                payload,
                error,
                errorMessage,
            };
        default:
            return state;
    }
}
